/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationReference } from './HomeHealthCertificationReference';
import {
    HomeHealthCertificationReferenceFromJSON,
    HomeHealthCertificationReferenceFromJSONTyped,
    HomeHealthCertificationReferenceToJSON,
    HomeHealthCertificationReferenceToJSONTyped,
} from './HomeHealthCertificationReference';
import type { HomeHealthCertificationReviewReason } from './HomeHealthCertificationReviewReason';
import {
    HomeHealthCertificationReviewReasonFromJSON,
    HomeHealthCertificationReviewReasonFromJSONTyped,
    HomeHealthCertificationReviewReasonToJSON,
    HomeHealthCertificationReviewReasonToJSONTyped,
} from './HomeHealthCertificationReviewReason';

/**
 * 
 * @export
 * @interface HomeHealthCertificationDisciplineOrder
 */
export interface HomeHealthCertificationDisciplineOrder {
    /**
     * 
     * @type {HomeHealthCertificationStatus}
     * @memberof HomeHealthCertificationDisciplineOrder
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     * @type {Array<HomeHealthCertificationReviewReason>}
     * @memberof HomeHealthCertificationDisciplineOrder
     */
    review_reasons: Array<HomeHealthCertificationReviewReason>;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationDisciplineOrder
     */
    intent: HomeHealthCertificationDisciplineOrderIntentEnum;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationDisciplineOrder
     */
    service_detail: string;
    /**
     * 
     * @type {Array<HomeHealthCertificationReference>}
     * @memberof HomeHealthCertificationDisciplineOrder
     */
    ref: Array<HomeHealthCertificationReference>;
}


/**
 * @export
 */
export const HomeHealthCertificationDisciplineOrderIntentEnum = {
    EvaluateOnly: 'evaluate_only',
    EvaluateAndTreat: 'evaluate_and_treat',
    Generic: 'generic',
    Unspecified: 'unspecified'
} as const;
export type HomeHealthCertificationDisciplineOrderIntentEnum = typeof HomeHealthCertificationDisciplineOrderIntentEnum[keyof typeof HomeHealthCertificationDisciplineOrderIntentEnum];


/**
 * Check if a given object implements the HomeHealthCertificationDisciplineOrder interface.
 */
export function instanceOfHomeHealthCertificationDisciplineOrder(value: object): value is HomeHealthCertificationDisciplineOrder {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('review_reasons' in value) || value['review_reasons'] === undefined) return false;
    if (!('intent' in value) || value['intent'] === undefined) return false;
    if (!('service_detail' in value) || value['service_detail'] === undefined) return false;
    if (!('ref' in value) || value['ref'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationDisciplineOrderFromJSON(json: any): HomeHealthCertificationDisciplineOrder {
    return HomeHealthCertificationDisciplineOrderFromJSONTyped(json, false);
}

export function HomeHealthCertificationDisciplineOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationDisciplineOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'review_reasons': ((json['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonFromJSON)),
        'intent': json['intent'],
        'service_detail': json['service_detail'],
        'ref': ((json['ref'] as Array<any>).map(HomeHealthCertificationReferenceFromJSON)),
    };
}

export function HomeHealthCertificationDisciplineOrderToJSON(json: any): HomeHealthCertificationDisciplineOrder {
    return HomeHealthCertificationDisciplineOrderToJSONTyped(json, false);
}

export function HomeHealthCertificationDisciplineOrderToJSONTyped(value?: HomeHealthCertificationDisciplineOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'review_reasons': ((value['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonToJSON)),
        'intent': value['intent'],
        'service_detail': value['service_detail'],
        'ref': ((value['ref'] as Array<any>).map(HomeHealthCertificationReferenceToJSON)),
    };
}

